/**
 * Regras de elegibilidade da devolução de Pix recebido.
 *
 * Mora fora do modal porque a tabela do extrato precisa da mesma decisão para
 * saber se mostra o botão "Devolver" — e importar o modal só por causa disso
 * arrastaria a árvore de componentes para dentro da tabela.
 */

export function isRefundEntry(item) {
  return (
    `${item?.type || ""}`.toUpperCase() === "REFUND" ||
    `${item?.operation_type || ""}`.toUpperCase() === "PAYIN_REFUND"
  );
}

export function getReceivedAmount(item) {
  const cents = Number(item?.amount_cents);
  if (
    typeof item?.amount_cents !== "undefined" &&
    item?.amount_cents !== null &&
    !Number.isNaN(cents)
  ) {
    return Math.abs(cents) / 100;
  }

  const amount = Number(item?.amount);
  return Number.isNaN(amount) ? 0 : Math.abs(amount) / 100;
}

/**
 * Um lançamento só pode ser devolvido quando é um Pix recebido que ainda tem a
 * ordem original identificada — a devolução é criada contra o orderId, não
 * contra o lançamento do extrato. Devoluções já feitas (o próprio PAYIN_REFUND,
 * ou um recebimento que já carrega refundId) ficam de fora para não gerar uma
 * segunda devolução sobre a mesma ordem.
 */
export function canRefund(item) {
  if (!item?.order_id) {
    return false;
  }

  if (`${item?.type || ""}`.toUpperCase() !== "CREDIT") {
    return false;
  }

  const operationType = `${item?.operation_type || ""}`.toUpperCase();
  if (operationType && operationType !== "PAYIN") {
    return false;
  }

  if (item?.refund_id) {
    return false;
  }

  return getReceivedAmount(item) > 0;
}
